export default {

    GET_REPORTS_SUMMARIES_REQUEST: state => {
        state.reportsSummariesLoading = true
    },
    GET_REPORTS_SUMMARIES_SUCCESS: (state, data) => {
        state.reportsSummaries = data.results
        state.reportsSummariesLoading = false
    },
    GET_REPORTS_SUMMARIES_FAILURE: state => {
        state.reportsSummariesLoading = false
    },
    SET_REPORTS_SUMMARIES_FILTERS: (state, filters) => {
        state.reportsSummariesFilters = filters
    },
    CLEAR_REPORTS_SUMMARIES_FILTERS: state => {
        state.reportsSummariesFilters = state.setInitialReportsSummariesFilters()
    }
}